import $ from 'jquery';
import { Collapse } from 'bootstrap/dist/js/bootstrap.esm.js';

initInputRangeTrackProgressSync();
initRadioCollapseToggle();
initSelectToggle();

/**
 * Cross browser track-progress sync for input[type="range"]
 * with CSS custom properties.
 *
 * @see .form-range at css/atomics/forms.scss
 */
function initInputRangeTrackProgressSync() {
    $('input[type="range"]').on('change input', (event) => {
        const input = event.target;
        input.style.setProperty('--val', input.value);
    });
}

/**
 * Additional handling for radio buttons which trigger collapsible
 *
 * This ensures correct triggering while navigating with a keyboard.
 */
function initRadioCollapseToggle() {
    const $radios = $(
        'input[type="radio"][data-bs-toggle="collapse"]'
    );

    if ($radios.length) {
        // Toggle on load
        $radios.each((index, element) => {
            const $radio = $(element);
            const $radioGroup = $(`[name="${$radio.attr('name')}"]`);
            const $collapseTarget = $($radio.data('bs-target'));

            __toggleRadioTarget($radio, $collapseTarget);

            // Toggle on change
            $radioGroup.on('change', (event) => {
                const $changedRadio = $(event.delegateTarget);

                // Disable radio: prevent multiple parallel runs
                $changedRadio.prop('disabled', true);

                // Re-enable radio button
                if ($changedRadio.prop('disabled') === true) {
                    $collapseTarget[0].addEventListener('shown.bs.collapse', reEnableRadio);
                    $collapseTarget[0].addEventListener('hidden.bs.collapse', reEnableRadio);

                    function reEnableRadio() {
                        $changedRadio.prop('disabled', false);
                        $collapseTarget[0].removeEventListener('shown.bs.collapse', reEnableRadio);
                        $collapseTarget[0].removeEventListener('hidden.bs.collapse', reEnableRadio);
                        $changedRadio[0].focus();
                    }
                }

                __toggleRadioTarget($radio, $collapseTarget);
            });
        });

        /**
         * @param {jQuery} $radio
         * @param {jQuery} $collapseTarget
         */
        function __toggleRadioTarget($radio, $collapseTarget) {
            // Important: init collapsible beforehand
            const collapseInstance = new Collapse($collapseTarget[0], {
                toggle: false,
            });

            if ($radio.prop('checked') === true) {
                collapseInstance.show();
                $radio.attr('data-toggle', null);
                $radio.attr('aria-pressed', 'true');
            } else {
                collapseInstance.hide();
                $radio.attr('data-toggle', 'collapse');
                $radio.attr('aria-pressed', 'false');
            }
        }
    }
}

function initSelectToggle() {
    const $collapsibles = $('form .collapse');

    $collapsibles.each((index, element) => {
        const $collapsible = $(element);
        const $subCollapsible = $collapsible.find('.collapse');
        const $subCollapsibleInputs = $subCollapsible.find('input, select, textarea');
        const $collapsibleInputs = $collapsible.find('input, select, textarea').not($subCollapsibleInputs);

        if ($collapsibleInputs.length === 0) {
            return;
        }

        if( $collapsible.hasClass('show') === false) {
            disableInputs(undefined, $collapsibleInputs);
        }

        $collapsible[0].addEventListener('show.bs.collapse', (event) => enableInputs(event, $collapsibleInputs));
        $collapsible[0].addEventListener('hide.bs.collapse', (event) => disableInputs(event, $collapsibleInputs));
    });

    function disableInputs(event, $collapsibleInputs) {
        event?.stopPropagation();
        $collapsibleInputs.each((index, element) => {
            $(element).prop('disabled', true);
        });
    }

    function enableInputs(event, $collapsibleInputs) {
        event?.stopPropagation();
        $collapsibleInputs.each((index, element) => {
            $(element).prop('disabled', false);
        });
    }
}
